import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamPeriodMonitor } from "@types";

export const useGetExamInstanceMonitor = (examPeriodId: string) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const getExamInstanceMonitor = async () => {
        try {
            const response = await axios.post<ExamPeriodMonitor[]>(`/api/examinstance/monitor/${examPeriodId}`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExamInstanceMonitor"));
        }
    }

    return useQuery({ queryKey: ["examPeriods", examPeriodId, "monitor"], queryFn: getExamInstanceMonitor, refetchOnWindowFocus: false, refetchOnMount: "always", refetchInterval: 15000});

}